var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "video-wrapper" }, [
      _c("div", { staticClass: "mask" }),
      _vm._v(" "),
      _c("div", { staticClass: "textfont" }, [_vm._v("请面向屏幕")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("img", {
          staticClass: "facebox",
          attrs: { src: require("../../src/assets/images/facebox.png") }
        }),
        _vm._v(" "),
        _c("video", {
          attrs: {
            id: "video",
            width: "480",
            height: "320",
            preload: "",
            autoplay: "",
            loop: "",
            muted: "",
            playsinline: "",
            "webkit-playsinline": "true"
          },
          domProps: { muted: true }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "takepic",
          attrs: { id: "capture" },
          on: { click: _vm.tackpic }
        },
        [_vm._v("拍照")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "zy" }, [
        _vm._v(
          "注:如果苹果手机无法打开摄像头，请将您的IOS系统升级至15.0或15.0以上"
        )
      ])
    ]),
    _vm._v(" "),
    _c("canvas", {
      staticStyle: { display: "none" },
      attrs: { id: "canvas", width: "480", height: "320" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4357d21a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4357d21a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceRecognition.vue
// module id = null
// module chunks = 